import { ComplianceComponent } from "@/features";
import { Deal } from "@/types";

interface Props {
  isLoading: boolean
  deals: Deal[]
  onRefresh?: () => void
  onNavigateToDocuments?: () => void
  currentDeal: Deal | null
  onDealChange: (deal: Deal) => void
}

export const CompliancePage = ({ deals, isLoading, onRefresh, onNavigateToDocuments, currentDeal, onDealChange }: Props) => {
  return <ComplianceComponent deals={deals} isLoading={isLoading} onRefresh={onRefresh} onNavigateToDocuments={onNavigateToDocuments} currentDeal={currentDeal} onDealChange={onDealChange} />;
}
